import ToddleDocRoute from "AppComponents/ToddleDocRoute";

export default store => ({
  path: "toddleDoc",
  childRoutes: [ToddleDocRoute(store)],
});
